<!-- Widget trigger -->
<div class="how-it-works-widget text-center" role="button" (click)="openModal()" style="cursor: pointer;">
  <p class="how-it-works-title mb-1">{{ 'home.how.it.works.title' | translate }}</p>
  <p class="how-it-works-body mb-0">{{ 'home.how.it.works.body' | translate }}</p>
</div>

<!-- Modal Template -->
<ng-template #howItWorksModal let-modal>
  <div class="hiw-modal-content">
    <!-- Header -->
    <div class="hiw-modal-header d-flex justify-content-between align-items-center mb-3">
      <h2 class="hiw-modal-title mt-0 mb-0">{{ 'home.how.it.works.title' | translate }}</h2>
      <button class="hiw-close-btn" (click)="modal.dismiss()" aria-label="Close">
        <span class="material-symbols-outlined" aria-hidden="true">close</span>
      </button>
    </div>

    <!-- Subtitle -->
    <p class="hiw-modal-subtitle mb-4">{{ 'home.how.it.works.body' | translate }}</p>

    <!-- Steps -->
    <div class="row g-3 mb-4">
      <!-- Step 1 -->
      <div class="col-12 col-lg-4">
        <div class="hiw-step-card bg-glass h-100">
          <img
            class="hiw-step-img"
            [src]="'how-it-works/linking.jpg' | contentAssetImage"
            alt="{{ 'home.how.it.works.step1.title' | translate }}"
          />
          <p class="hiw-step-title">{{ 'home.how.it.works.step1.title' | translate }}</p>
          <div class="hiw-step-body mb-0" [innerHTML]="'home.how.it.works.step1.body' | translate | markdownTranslate"></div>
        </div>
      </div>

      <!-- Step 2 -->
      <div class="col-12 col-lg-4">
        <div class="hiw-step-card bg-glass h-100">
          <img
            class="hiw-step-img"
            [src]="'how-it-works/scan.jpg' | contentAssetImage"
            alt="{{ 'home.how.it.works.step2.title' | translate }}"
          />
          <p class="hiw-step-title">{{ 'home.how.it.works.step2.title' | translate }}</p>
          <div class="hiw-step-body mb-0" [innerHTML]="'home.how.it.works.step2.body' | translate | markdownTranslate"></div>
        </div>
      </div>

      <!-- Step 3 -->
      <div class="col-12 col-lg-4">
        <div class="hiw-step-card bg-glass h-100">
          <img
            class="hiw-step-img"
            [src]="'how-it-works/pay.jpg' | contentAssetImage"
            alt="{{ 'home.how.it.works.step3.title' | translate }}"
          />
          <p class="hiw-step-title">{{ 'home.how.it.works.step3.title' | translate }}</p>
          <div class="hiw-step-body mb-0" [innerHTML]="'home.how.it.works.step3.body' | translate | markdownTranslate"></div>
        </div>
      </div>
    </div>

    <!-- Got it button -->
    <div class="d-flex justify-content-center">
      <button class="hiw-got-it-btn" (click)="modal.dismiss()">
        {{ 'home.how.it.works.got.it' | translate }}
      </button>
    </div>
  </div>
</ng-template>
